import api from '../../services/api';
import { Creators } from '../ducks/theme';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getThemes({ filter }) {
  try {
    yield put(Creators.themeRequest());
    const response = yield call(api.post, 'theme', filter);

    yield put(Creators.themeSuccess(filter.chip, response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.themeError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao listar temas'
    }));
  }
}